import main from './navigation-accordion';
export default main;